import { QueryClient, useQuery } from '@tanstack/vue-query';
import { computed, onUnmounted, toValue, type MaybeRefOrGetter } from 'vue';

import { getAboutContentPage } from '../api/about.api';

export const useAboutContentPageQuery = (slug: MaybeRefOrGetter<string>) => {
  const queryClient = new QueryClient();

  queryClient.mount();
  onUnmounted(() => {
    queryClient.unmount();
  });

  return useQuery(
    {
      queryKey: computed(() => ['about-content-page', toValue(slug)]),
      queryFn: () => getAboutContentPage(toValue(slug)),
      enabled: computed(() => Boolean(toValue(slug))),
    },
    queryClient,
  );
};
